export const IdentityProvider = {
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER',
} as const;
export type IdentityProvider = (typeof IdentityProvider)[keyof typeof IdentityProvider];
export const LinkRequiredReasonEnum = {
  EMAIL_MATCH: 'email_match',
  EMAIL_MISS: 'email_missing',
} as const;
export type LinkRequiredReasonEnum =
  (typeof LinkRequiredReasonEnum)[keyof typeof LinkRequiredReasonEnum];
export const OauthResolveKind = {
  SIGNED_IN: 'signed_in',
  SIGNED_UP: 'signed_up',
  LINK_REQUIRED: 'link_required',
} as const;
export type OauthResolveKind = (typeof OauthResolveKind)[keyof typeof OauthResolveKind];
